import styled, { css } from 'react-emotion'

export const resumeVideoContainer = css`
  margin: 0 0 4rem 0;

  @media screen and (max-width: 640px) {
    margin: 0 0 32px 0;

    .carouselWrapper {
      padding: 1rem 0 0 0 !important;
    }

    .slider-frame {
      margin: 0px !important;
    }
  }
`

export const playlistHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  h3 {
    padding: 0;
    color: #cbcbcb;
    font-size: 1.5rem;
    display: inline-block;
    vertical-align: middle;
    font-weight: 400;
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    width: 8rem;
    height: 1.25rem;
    font-weight: 400;
    color: #969696;
    // border: 0.112rem solid #969696;
    border-radius: 3rem;
    padding: 0.5rem;
    transition: all ease 500ms;
  }

  a:hover {
    color: #ffffff;
  }

  @media screen and (max-width: 640px) {
    h3 {
      color: #cbcbcb;
      font-size: 15px;
    }

    a {
      font-size: 12px;
      margin: 0 5px;
      padding: 5px;
      border-width: 1px;
    }
  }
`

export const textRight = css`
a {
  justify-content: flex-end;
  margin: 0;
}
`

export const BannerWrapper = styled('div')`
  padding: 0;
  margin-bottom: 4rem;

  @media screen and (max-width: 640px) {
    padding: 0;
    margin-bottom: 32px;
  }
`